import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg height={height}
      width={width}
      {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.6666 9.33325V6.66658C13.6666 4.15243 13.6666 2.89535 12.8856 2.1143C12.1046 1.33325 10.8475 1.33325 8.33331 1.33325H7.66671C5.15259 1.33325 3.89553 1.33325 3.11448 2.11429C2.33343 2.89533 2.33342 4.1524 2.3334 6.66654L2.33337 9.33318C2.33335 11.8474 2.33334 13.1045 3.11439 13.8855C3.89544 14.6666 5.15253 14.6666 7.66671 14.6666H8.33331C10.8475 14.6666 12.1046 14.6666 12.8856 13.8855C13.6666 13.1045 13.6666 11.8474 13.6666 9.33325Z" stroke="#72808F" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.33337 4.66675H10.6667M5.33337 8.00008H10.6667M5.33337 11.3334H8.00004" stroke="#72808F" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export default SvgComponent
